import React from 'react';
import classnames from 'classnames';
import PromoIcon from 'images/icons/tag.svg?react-svg';
import margin from 'scy/margin.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import { packageQtyDiscount } from 'shared/models/product';

export default function QtyDiscount({
  product,
  className,
  iconWidth,
  iconHeight
}) {
  const text = packageQtyDiscount(product);
  return !text ? null : (
    <div className={classnames(flex, centerItems, className)}>
      <PromoIcon width={iconWidth || 22} height={iconHeight || 22} />
      <span className={margin.xs}>{text}</span>
    </div>
  );
}
